const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 90,
    width: 90,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEDEF"
    },
    d: "M100.641,0c-14.139,0-25.6,11.461-25.6,25.6v460.8c0,14.139,11.461,25.6,25.6,25.6h375.467 c14.139,0,25.6-11.461,25.6-25.6V85.333L416.375,0H100.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M441.975,85.333h59.733L416.375,0v59.733C416.375,73.872,427.836,85.333,441.975,85.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6CACF"
    },
    d: "M399.308,42.667H75.041v153.6h324.267c4.713,0,8.533-3.821,8.533-8.533V51.2 C407.841,46.487,404.02,42.667,399.308,42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4DF64"
    },
    d: "M382.241,179.2H18.843c-7.602,0-11.41-9.191-6.034-14.567L75.041,102.4L12.809,40.167 C7.433,34.791,11.241,25.6,18.843,25.6h363.398c4.713,0,8.533,3.821,8.533,8.533v136.533 C390.775,175.379,386.954,179.2,382.241,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6CACF"
    },
    d: "M399.308,460.8H177.441c-4.713,0-8.533-3.821-8.533-8.533V230.4c0-4.713,3.821-8.533,8.533-8.533 h221.867c4.713,0,8.533,3.821,8.533,8.533v221.867C407.841,456.979,404.02,460.8,399.308,460.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M185.975,443.733V221.867h-8.533c-4.713,0-8.533,3.821-8.533,8.533v221.867 c0,4.713,3.821,8.533,8.533,8.533h221.867c4.713,0,8.533-3.821,8.533-8.533v-8.533H185.975z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M185.975,145.067h-25.6c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533 h25.6c4.713,0,8.533,3.821,8.533,8.533s-3.821,8.533-8.533,8.533h-17.067V128h17.067c4.713,0,8.533,3.821,8.533,8.533 S190.687,145.067,185.975,145.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.175,145.067h-25.6c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h17.067v-8.533 h-17.067c-4.713,0-8.533-3.821-8.533-8.533v-25.6c0-4.713,3.821-8.533,8.533-8.533h25.6c4.713,0,8.533,3.821,8.533,8.533 s-3.821,8.533-8.533,8.533h-17.067v8.533h17.067c4.713,0,8.533,3.821,8.533,8.533v25.6 C245.708,141.246,241.887,145.067,237.175,145.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.841,145.067c-3.673,0-6.934-2.351-8.096-5.835l-17.067-51.2 c-1.489-4.47,0.926-9.303,5.397-10.794c4.477-1.492,9.303,0.926,10.795,5.397l8.971,26.913l8.971-26.913 c1.491-4.47,6.322-6.886,10.795-5.397c4.47,1.49,6.886,6.323,5.397,10.794l-17.067,51.2 C286.776,142.716,283.515,145.067,279.841,145.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M237.175,273.067h-34.133c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h34.133 c4.713,0,8.533,3.821,8.533,8.533C245.708,269.246,241.887,273.067,237.175,273.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M373.708,273.067h-102.4c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h102.4 c4.713,0,8.533,3.821,8.533,8.533C382.241,269.246,378.42,273.067,373.708,273.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M237.175,324.267h-34.133c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h34.133 c4.713,0,8.533,3.821,8.533,8.533C245.708,320.446,241.887,324.267,237.175,324.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M373.708,324.267h-102.4c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h102.4 c4.713,0,8.533,3.821,8.533,8.533C382.241,320.446,378.42,324.267,373.708,324.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M237.175,375.467h-34.133c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h34.133 c4.713,0,8.533,3.821,8.533,8.533S241.887,375.467,237.175,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M296.908,375.467h-25.6c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h25.6 c4.713,0,8.533,3.821,8.533,8.533S301.62,375.467,296.908,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M237.175,426.667h-34.133c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h34.133 c4.713,0,8.533,3.821,8.533,8.533S241.887,426.667,237.175,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M296.908,426.667h-25.6c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h25.6 c4.713,0,8.533,3.821,8.533,8.533S301.62,426.667,296.908,426.667z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#529E44"
    },
    d: "M363.483,392.533l16.781-20.137c3.018-3.621,2.528-9.002-1.092-12.019 c-3.619-3.017-9.001-2.529-12.018,1.092l-14.778,17.733l-14.778-17.733c-3.017-3.619-8.398-4.109-12.018-1.092 c-3.621,3.018-4.111,8.398-1.092,12.019l16.78,20.137l-16.781,20.137c-2.754,3.305-2.574,8.309,0.425,11.399 c3.484,3.59,9.485,3.368,12.686-0.474l14.778-17.733l14.778,17.733c3.201,3.842,9.202,4.063,12.686,0.474 c2.998-3.09,3.179-8.095,0.425-11.399L363.483,392.533z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.0ae44f8db7d6d7c4686565ff88015fc5.svg";
export { ForwardRef as ReactComponent };